import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { DateService } from 'src/app/shared/services/date.service';
import { UserService } from 'src/app/shared/services/user.service';
import { environment } from 'src/environments/environment';

import HijriDate from 'hijri-date/lib/safe';
@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {

  constructor(
    private _router: Router,
    private _dateService: DateService,
    public userService: UserService) { }

  ngOnInit(): void {
  }
 
  public navigateToHomePage() {
    this._router.navigate([AppConstants.ROUTES.HOME, AppConstants.ROUTES.MAIN]);
    // location.href="home/main";
  }
  public navigateToRequests() {
    this._router.navigate([AppConstants.ROUTES.HOME, AppConstants.ROUTES.REQUESTS]);
    // location.href="home/requests";
  }
  public navigateToServices() {
    //this._activeRoute = 'services';
    this._router.navigate([AppConstants.ROUTES.HOME, AppConstants.ROUTES.SERVICES]);
    // location.href="home/requests";
  }
  public navigatToMyAccount() {
    this._router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.MY_ACCOUNT]);
    // location.href="authentication/my-profile";
  }
  public logout() {
    this.userService.logout();
    this._router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.LOGIN]);
    // location.href="authentication";
  }
  public navigateToPrivacyPolicy() {
    this._router.navigate([AppConstants.ROUTES.HOME, AppConstants.ROUTES.PRIVACY_POLICY]);
    // location.href="home/policy";
  }
  
  public navigateToContactUss() {
    this._router.navigate([AppConstants.ROUTES.HOME, AppConstants.ROUTES.CONTACT_US]);
    // location.href="home/contact-us";
  }
  public navigateToUsibilityConditions() {
    this._router.navigate([AppConstants.ROUTES.HOME, AppConstants.ROUTES.USIBILITY_CONDITIONS]);
    // location.href="home/usibility-conditions";
  }
  public navigateToSiteMap() {
    this._router.navigate([AppConstants.ROUTES.HOME, AppConstants.ROUTES.SITE_MAP]);
    // location.href="home/site-map";
  }



  public changeFontSize(type: string) {
    let size: number = 0;
    let className: string = 'fontSize-';
    const html = document.getElementsByTagName("html")[0];
    let sizestr = localStorage.getItem('font');
    if(sizestr) {
      size = +sizestr;
      if(size>-2 && type === "decrease") {
        size -= 1;
        className = className+size;
        html.setAttribute('class', className);
        localStorage.setItem('font', size.toString());
      } else if(size<2 && type === "increase") {
        size+=1;
        className = className+size;
        html.setAttribute('class', className);
        localStorage.setItem('font', size.toString());
      }
      
      
    }
  }
  public onChangeBehavior(text: string) {
    const theme = localStorage.getItem("theme");
    if(theme) {
      if(theme === 'default') {
        document.body.className = document.body.className.replace('default', text);
        localStorage.setItem('theme', text);
      } else {
        document.body.className = document.body.className.replace('colorBlindTheme', text);
        localStorage.setItem('theme', text);
      }
    }
  }
  public isDefaultTheme() {
    let theme = localStorage.getItem("theme");
    return theme && theme === 'default';
  }

}
